import type { BaseKeyFunction } from "../../../../lib";

export const keySessionsCount: BaseKeyFunction = () => ["sessions", "count"];
